import { put, takeEvery,call  } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_PRODUCTRETURNDETAILS_INIT_ACTION,
  FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION,
  FETCH_PRODUCTRETURNDETAILS_FAIL_ACTION,
  FETCH_PRODUCTRETURNVIEW_INIT_ACTION,
  FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION,
  FETCH_PRODUCTRETURNVIEW_FAIL_ACTION,
  ADD_CREDITNOTES_INIT_ACTION,
  ADD_CREDITNOTES_SUCCESS_ACTION,
  ADD_CREDITNOTES_FAIL_ACTION,
  FETCH_RETUNREJECTED_INIT_ACTION,
  FETCH_RETUNREJECTED_SUCCESS_ACTION,
  FETCH_RETUNREJECTED_FAIL_ACTION,
  FETCH_RETUNACCEPTED_INIT_ACTION,
  FETCH_RETUNACCEPTED_SUCCESS_ACTION,
  FETCH_RETUNACCEPTED_FAIL_ACTION,
  PDF_RETURN_REPORT_INIT_ACTION,
  PDF_RETURN_REPORT_SUCCESS_ACTION,
  PDF_RETURN_REPORT_FAIL_ACTION,
  FETCH_ORDERDETAIL_ACCEPT_INIT,
  FETCH_ORDERDETAIL_REJECT_INIT,
  UPDATE_APPROVED_QTY_INIT,
  UPDATE_APPROVED_QTY_SUCCESS,
  UPDATE_APPROVED_QTY_FAIL,
  UPDATE_PURCHASEORDER_TOTALS_INIT,
  UPDATE_PURCHASEORDER_TOTALS_SUCCESS,
  UPDATE_PURCHASEORDER_TOTALS_FAIL,
} from "./action";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import "jspdf-autotable";

var history = createBrowserHistory();

function* fetchPurchaseReturns(value) {
  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");

  let pageno = !value.value
    ? 1
    : value.value.page === undefined
    ? 1
    : value.value.page;
  let searchquery = !value.value
    ? ""
    : value.value === undefined
    ? ""
    : value.value.searchquery;
  let status = !value.value
    ? ""
    : value.value === undefined
    ? ""
    : value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=return&orderTo=${distributorProfId}&search=${searchquery}&status=${status}&limit=10&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PRODUCTRETURNDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchProductReturnview(value) {
  const token = localStorage.getItem("token");

  const orderId = value.value.item.item.id;
  const pageno = value.value.page === undefined ? 1 : value.value.page;

  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=${orderId}&limit=5&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PRODUCTRETURNVIEW_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* CreditNotesAdd(value) {
  console.log(value,">>>>>>>>>>>>>>>>>>>>>>CreditNotesAdd");
  try {
    const token = localStorage.getItem("token");
    const distributorProfId = localStorage.getItem("distributorId");
    const formData = new FormData();

    formData.append("attachmentType",'credit-notes');
    // formData.append("file", value.value.file, "name");
    formData.append("name", "icon");
    formData.append("icon", value.value.imgUrl, value.value.imgUrl.name);

    const res = yield fetch(`${appConfig.ip}/attachments/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json(); 
      const data = {
        crdtTo: value.value.crdtTo,
        crdtFrom: value.value.crdtFrom,
        crdtToGST: value.value.crdtToGST,
        addrInfoChmst: value.value.addrInfoChmst,
        descp: value.value.descp,
        qnty: value.value.qnty,
        amnt: value.value.amnt,
        imgUrl: resJSON.data.documentUrl,
        returnId: value.value.id,
      };
      const Categry = yield fetch(
        `${appConfig.ip}/creditNotes?crdtFrom=${distributorProfId}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );

      if (!Categry.ok) {
      } else {
        const categryJSON = yield Categry.json();
        yield put({
          type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION,
        });
        yield toast.success("Credit note uploaded", {
          autoClose: 3000,
          transition: Flip,
        });
        yield put({
          type: ADD_CREDITNOTES_SUCCESS_ACTION,
          payload: categryJSON,
        });
      }
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_CREDITNOTES_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* returnrejected(value) {
  const token = localStorage.getItem("token");
  const orderId = value.value.order.item.id;

  const {
    approvedQtyMap,
    approvedAmountMap,
    totalApprovedAmount,
    totalClaimAmount,
  } = value.value;

  try {
    // 1️⃣ Update totals (approved = 0)
    yield call(updatePurchaseOrderTotalsSaga, {
      value: {
        orderId,
        totalApprovedAmount,
        totalClaimAmount,
      },
    });

    // 2️⃣ Update status
    yield fetch(`${appConfig.ip}/purchaseOrder/changeStatus/${orderId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status: "rejected" }),
    });

    // 3️⃣ Update items
    for (const itemId in approvedQtyMap) {
      yield put({
        type: UPDATE_APPROVED_QTY_INIT,
        value: {
          id: itemId,
          approvedQntty: approvedQtyMap[itemId],
          approvedAmount: approvedAmountMap[itemId],
        },
      });
    }

    yield toast.success("Purchase return rejected", {
      autoClose: 3000,
      transition: Flip,
    });

    yield put({ type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION });
  } catch (err) {
    console.error(err);
  }
}


function* returnaccept(value) {
  const token = localStorage.getItem("token");
  const orderId = value.value.order.item.id;

  const {
    approvedQtyMap,
    approvedAmountMap,
    totalApprovedAmount,
    totalClaimAmount,
  } = value.value;

  try {
    // 1️⃣ Update order totals
    yield call(updatePurchaseOrderTotalsSaga, {
      value: {
        orderId,
        totalApprovedAmount,
        totalClaimAmount,
      },
    });

    // 2️⃣ Update order status
    yield fetch(`${appConfig.ip}/purchaseOrder/changeStatus/${orderId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status: "accepted" }),
    });

    // 3️⃣ Update each item
    for (const itemId in approvedQtyMap) {
      yield put({
        type: UPDATE_APPROVED_QTY_INIT,
        value: {
          id: itemId,
          approvedQntty: approvedQtyMap[itemId],
          approvedAmount: approvedAmountMap[itemId],
        },
      });
    }

    yield toast.success("Purchase return accepted", {
      autoClose: 3000,
      transition: Flip,
    });

    yield put({ type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION });
  } catch (err) {
    console.error(err);
  }
}


function* returnacceptOne(value) {
  let datas = { orderStatus: "approved" };
  const { id, orderId, approvedQntty, approvedAmount } = value.value;
  const token = localStorage.getItem("token");

  try {
    yield put({
      type: UPDATE_APPROVED_QTY_INIT,
      value: {
        id,
        approvedQntty,
        approvedAmount,
      },
    });

    const res = yield fetch(`${appConfig.ip}/orderDetails/changeStatus/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });

    if (!res.ok) throw res;

    yield toast.success("Item accepted", {
      autoClose: 3000,
      transition: Flip,
    });

    // 🔁 REFRESH MODAL ITEMS
    yield put({
      type: FETCH_PRODUCTRETURNVIEW_INIT_ACTION,
      value: {
        item: { item: { id: orderId } },
        page: 1,
      },
    });

    // 🔥 REFRESH MAIN PURCHASE RETURNS LIST (THIS WAS MISSING)
    yield put({
      type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION,
      value: {
        page: 1,
        filter: "",
        searchquery: "",
      },
    });
  } catch (err) {
    console.error(err);
  }
}

function* returnrejectedOne(value) {
  let datas = { orderStatus: "rejected" };
  const { id, orderId, approvedQntty, approvedAmount } = value.value;
  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");
  try {
    yield put({
      type: UPDATE_APPROVED_QTY_INIT,
      value: {
        id,
        approvedQntty,
        approvedAmount,
      },
    });

    const res = yield fetch(`${appConfig.ip}/orderDetails/changeStatus/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });

    if (!res.ok) throw res;

    yield toast.success("Item Rejected", {
      autoClose: 3000,
      transition: Flip,
    });

    // ✅ REFRESH ITEM LIST
    yield put({
      type: FETCH_PRODUCTRETURNVIEW_INIT_ACTION,
      value: {
        item: { item: { id: orderId } },
        page: 1,
      },
    });

    yield put({
      type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION,
      value: {
        page: 1,
        filter: "",
        searchquery: "",
      },
    });
  } catch (err) {
    console.error(err);
  }
}

function* updateApprovedQuantity(value) {
  const token = localStorage.getItem("token");
  const { id, approvedQntty, approvedAmount } = value.value;

  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        approvedQntty,
        approvedAmount,
      }),
    });

    if (!res.ok) throw res;

    yield put({
      type: UPDATE_APPROVED_QTY_SUCCESS,
      payload: {
        id,
        approvedQntty,
        approvedAmount,
      },
    });

    // refresh data
    yield put({ type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION });
  } catch (err) {
    yield put({ type: UPDATE_APPROVED_QTY_FAIL, error: err });
  }
}

function* updatePurchaseOrderTotalsSaga(action) {
  const token = localStorage.getItem("token");
  const { orderId, totalApprovedAmount, totalClaimAmount } = action.value;

  try {
    const res = yield fetch(`${appConfig.ip}/purchaseOrder/${orderId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        totalApprovedAmount,
        totalClaimAmount,
      }),
    });

    if (!res.ok) throw res;

    yield put({
      type: UPDATE_PURCHASEORDER_TOTALS_SUCCESS,
      payload: {
        orderId,
        totalApprovedAmount,
        totalClaimAmount,
      },
    });
  } catch (err) {
    yield put({
      type: UPDATE_PURCHASEORDER_TOTALS_FAIL,
      error: err,
    });
  }
}

function* pdfreturnFullData(value) {
  console.log("4444444444444444444444", value);
  const token = localStorage.getItem("token");
  const orderId = value.value.item.orderDetail.orderId.id;
  const ordername = value.value.item.orderFrom.fullName;
  const ordermob = value.value.item.orderFrom.mobileNo;
  const orderNo = value.value.item.orderNo;
  const email = value.value.item.chmstDtls.email;
  const address = value.value.item.addr + value.value.item.pincode;
  const pharmacy = value.value.item.orderFrom.orgName;
  const city = value.value.item.city;
  console.log("333333333333333333333333333", orderId);

  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails?orderId=${orderId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      const count = resJSON.count;
      console.log("count@@@@@@@@@@@@2", count);
      console.log("5555555555555555555555555555", resJSON);
      const doc = new jsPDF("p", "mm", "a4");
      const tableColumn = [
        "#",
        "Item Code",
        "Item Name",
        "Qnt",
        "Batch No",
        "Claim Amt",
        "Purchase Inv No",
        "Purchase Date",
        "Expiry Date",
      ];
      const tableRows = [];
      resJSON.rows.forEach((report, i) => {
        const reportData = [
          i + 1,
          report.itemCode?.drugCode || "-",
          report.itemCode?.drugName || "-",
          report.qntty || "-",
          report.batchNo,
          report.claimAmount,
          report.purchaseInvoiceNo,
          report.purchaseDate
            ? new Date(report.purchaseDate).toLocaleDateString()
            : "-",
          report.expiryDate
            ? new Date(report.expiryDate).toLocaleDateString()
            : "-",
        ];

        tableRows.push(reportData);
      });

      // doc.autoTable(tableColumn, tableRows, {
      //   startY: 65,

      // });
      doc.autoTable(tableColumn, tableRows, {
        theme: "grid",
        styles: {
          halign: "left",
        },
        headerStyles: {
          fillColor: [255, 0, 0],
          halign: "center",
        },
        margin: {
          top: 65,
        },
      });

      doc.setFontSize(10);
      doc.text(`Order No : ${orderNo}`, 11, 13, {
        float: "right",
        marginRight: "200px",
      });
      doc.setFontSize(10);
      doc.text(`Name : ${ordername}`, 11, 19);
      doc.setFontSize(10);
      doc.text(`Pharmacy : ${pharmacy}`, 11, 25);
      doc.setFontSize(10);
      doc.text(`Mobile : ${ordermob}`, 11, 30);
      doc.setFontSize(10);
      doc.text(`Email : ${email}`, 11, 35);
      doc.setFontSize(10);
      doc.text(`Address : ${address}`, 11, 40);
      doc.setFontSize(10);
      doc.text(`City : ${city}`, 11, 45);

      // doc.save(ordername.pdf);
      doc.setFontSize(13);
      doc.text("Item Details", 11, 55);
      doc.setFontSize(12);
      doc.text(`${count} Items`, 11, 60);
      doc.save(`${ordername}- ${orderNo}.pdf`);

      yield put({
        type: PDF_RETURN_REPORT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: PDF_RETURN_REPORT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* PurchaseReturnsActionWatcher() {
  yield takeEvery(FETCH_PRODUCTRETURNDETAILS_INIT_ACTION, fetchPurchaseReturns);
  yield takeEvery(FETCH_PRODUCTRETURNVIEW_INIT_ACTION, fetchProductReturnview);
  yield takeEvery(ADD_CREDITNOTES_INIT_ACTION, CreditNotesAdd);
  yield takeEvery(FETCH_RETUNREJECTED_INIT_ACTION, returnrejected);
  yield takeEvery(FETCH_RETUNACCEPTED_INIT_ACTION, returnaccept);
  yield takeEvery(PDF_RETURN_REPORT_INIT_ACTION, pdfreturnFullData);
  yield takeEvery(FETCH_ORDERDETAIL_ACCEPT_INIT, returnacceptOne);
  yield takeEvery(FETCH_ORDERDETAIL_REJECT_INIT, returnrejectedOne);
  yield takeEvery(UPDATE_APPROVED_QTY_INIT, updateApprovedQuantity);
  yield takeEvery(
    UPDATE_PURCHASEORDER_TOTALS_INIT,
    updatePurchaseOrderTotalsSaga
  );
}
